import PST from './hooks/PST';
import ProductSpecificationTextProvider from './hooks/useProductSpecificationText';

const ProductSpecificationText = (props: any) => {
	return (
		<ProductSpecificationTextProvider {...props}>
			<PST />
		</ProductSpecificationTextProvider>
	);
};

export default ProductSpecificationText;
